/**
 * Maps review platform strings to brand icons (Font Awesome).
 */
export function getPlatformIcon(platform = '') {
  const p = platform.toLowerCase();

  if (
    /playstation|ps5|ps4|ps3|ps2|ps1|psp|vita/.test(p) ||
    /\bps\d/.test(p)
  ) {
    return { type: 'playstation', icon: 'fab fa-playstation' };
  }

  if (/xbox/.test(p)) {
    return { type: 'xbox', icon: 'fab fa-xbox' };
  }

  if (/nintendo|switch|wii/.test(p)) {
    if (/switch/.test(p)) {
      return { type: 'nintendo', icon: 'fab fa-nintendo-switch' };
    }
    return { type: 'nintendo', icon: 'fab fa-nintendo' };
  }

  if (/pc|steam|windows|linux|mac|epic/.test(p)) {
    return { type: 'pc', icon: 'fas fa-desktop' };
  }

  return { type: 'generic', icon: 'fas fa-gamepad' };
}
